import loadable from '@loadable/component';

import { routes as authRoutes } from '../../../app/home/routes';

import path from 'path';

const ProfilePage = loadable(() => import('./user-profile/page'));
/* Common Routes across all the FE Repos */
export const routes = [
  {
    path: '',
    children: authRoutes,
  },
  {
    path: 'profile',
    element: <ProfilePage />,
  }
];
